import Axios from "axios";

export const getMe = async () => {

  const result = await Axios.get(process.env.VUE_APP_BACKEND_URL + `api/user`);

  return result;
}

export const userUpdate = async (body) => {

  const result = await Axios.put(process.env.VUE_APP_BACKEND_URL + `api/user`, body);

  return result;
}
